import React from 'react'
import { Model, useValue } from '@morningtrain/react-resources'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import * as Displays from 'support/displays'
import { observer } from 'mobx-react'

function CustomerInfo () {
  const id = useValue('customer_id')

  if (!id) return null

  return (
    <Model resourceName='customers' id={id}>
      <SmartviewTextGroup>
        <SmartviewText label='Kunde'>
          <div className='flex flex-col'>
            <span className='font-medium'>Kundenr:</span><Displays.Text name='customer_number' />
            <span className='font-medium'>Navn:</span><Displays.Text name='name' />
            <span className='font-medium'>E-mail:</span><Displays.Text name='email' />
          </div>
        </SmartviewText>
      </SmartviewTextGroup>
    </Model>
  )
}

export default observer(CustomerInfo)
